<script lang="ts">
	//UI
	import { AdaptiveTextInput, PhotoIcon } from "@hitit/new_ui/src";
	import DragAndDrop from "@hitit/hub/src/components/DragAndDrop.svelte";
	import StoreStatus from "./StoreStatus.svelte";

	//Utils
	import { t } from "@hitit/hub/src/stores";
	import { storeLogos } from "@hitit/hub/src/v7/store";
	//Types
	//Props
	export let editmode = false;
	export let storename = "";
	export let storeImageURL = "";
	export let storeStatus = "";
	//Constants
	const defaultImage = storeLogos.getDefaultImage();
	//Variables
	let loading = false;
	let image = "";
	let mouseenter = false;
	//Functions
	function loadImage(url: string) {
		try {
			loading = true;
			if (image && image !== defaultImage) {
				URL.revokeObjectURL(image);
			}
			if (url === "" || typeof url !== "string") {
				image = defaultImage;
				return;
			}
			// IMAGE From API
			// Will Remove
			image = url;
		} catch (error) {
			console.log(error);
		} finally {
			loading = false;
		}
	}
	async function fileUpdateHandler(e: any) {
		try {
			const file = e.detail;
			const extMatch = file.name.match(
				/(\.png|\.jpg|\.jpeg|\.JPG|\.JPEG|\.PNG)$/
			);
			if (!extMatch) return;
			const ext = extMatch[1].replace(".", "");
			// await GET image Key
			// await Load Image
			// Will Remove
			storeImageURL = URL.createObjectURL(file);
		} catch (error) {
			console.log(error);
		}
	}

	function deleteImage() {
		storeImageURL = "";
	}

	//Do
	$: loadImage(storeImageURL);

</script>

<div class="container" class:editmode>
	{#if !editmode}
		<div class="thumnail" style={`background-image : url(${image})`} />
		<div class="name-status">
			<h3 class="name">{storename}</h3>
			<StoreStatus status={storeStatus} />
		</div>
	{:else}
		<div class="status">
			<StoreStatus bind:status={storeStatus} editmode />
		</div>
		<div class="thumnail-title-delete-wrapper">
			<div class="thumnail" style={`background-image : url(${image})`}>
				<div
					class="drop-cover"
					on:dragover={() => {
						mouseenter = true;
					}}
					on:dragleave={() => {
						mouseenter = false;
					}}
					on:mouseleave={() => {
						mouseenter = false;
					}}
					on:mouseenter={() => {
						mouseenter = true;
					}}>
					<DragAndDrop on:file-update={fileUpdateHandler}>
						<div class="photoicon">
							<PhotoIcon active={mouseenter} />
						</div>
					</DragAndDrop>
				</div>
			</div>
			<div class="title-delete">
				<div class="title">
					<AdaptiveTextInput
						backgroundColor={'#f0f0f4'}
						bind:value={storename}
						placeholder={$t('hub.store.storeinfo.store_name')}>
						<i
							on:click={() => (storename = '')}
							slot="clear"
							class="clear-button">
							<svg
								xmlns="http://www.w3.org/2000/svg"
								width="100%"
								height="100%"
								viewBox="0 0 15 15">
								<line x1="0" y1="0" x2="15" y2="15" stroke-width="1" />
								<line x1="0" y1="15" x2="15" y2="0" stroke-width="1" />
							</svg>
						</i>
					</AdaptiveTextInput>
				</div>
				<img
					id="delete"
					src="/img/icons/deleteIcon.png"
					alt="delete"
					on:click={deleteImage} />
			</div>
		</div>
	{/if}
</div>

<style lang="scss">
	@import "../../../../variables.scss";
	.container {
		display: flex;
		align-items: center;
		gap: 10px;
		.thumnail {
			width: 41px;
			height: 41px;
			border: 1px solid #6591fa;
			background-color: #e6e7ed;
			border-radius: 999px;
			background-size: cover;
			background-repeat: no-repeat;
		}

		.name-status {
			display: flex;
			flex-wrap: wrap;
			align-items: center;

			gap: 6px;

			.name {
				font-size: 1.25rem;
				font-weight: 600;
				color: #46474b;
			}

			.status {
				font-size: 0.875rem;
			}
		}

		&.editmode {
			flex-direction: column;
			gap: 20px;
			align-items: flex-start;
			flex-wrap: wrap;
			.thumnail-title-delete-wrapper {
				display: flex;
				width: 100%;
			}

			.thumnail {
				width: 80px;
				height: 80px;
				position: relative;

				&:hover {
					cursor: pointer;
				}
			}
			.title-delete {
				display: flex;
				flex-direction: column;
				justify-content: space-between;
				flex-grow: 1;
				gap: 13px;

				.title {
					width: 100%;
					height: 31px;
					color: #46474b;
					font-size: 1.25rem;
				}

				#delete {
					width: 26px;
					height: 26.2px;
					object-fit: contain;

					&:hover {
						cursor: pointer;
					}
				}
			}

			.drop-cover {
				width: calc(100% - 1px);
				height: calc(100% - 1px);
				background-color: rgba($color: #46474b, $alpha: 0.8);
				border-radius: 100%;
				position: absolute;
				top: 50%;
				left: 50%;
				transform: translate(-50%, -50%);

				.photoicon {
					position: absolute;
					top: 50%;
					left: 50%;
					transform: translate(-50%, -50%);
					width: 40.3px;
					height: 40.5px;
				}
			}

			.clear-button {
				display: flex;
				justify-content: center;
				align-items: center;
				width: 15px;
				height: 15px;
			}
			svg {
				line {
					stroke: #bcbfc3;
					transition: stroke 0.15s;
				}
			}

			i:hover {
				cursor: pointer;

				line {
					stroke: #686a6d;
				}
			}
		}
	}

	@include DesktopSize {
		.container {
			gap: 20px;
			.thumnail {
				width: 64px;
				height: 64px;
				border: 2px solid #6591fa;
			}

			.name-status {
				gap: 10px;

				.name {
					font-size: 2.25rem;
				}
			}

			&.editmode {
				gap: 26px;
				flex-direction: row;
				align-items: center;
				.status {
					order: 2;
				}
				.thumnail-title-delete-wrapper {
					order: 1;
					width: auto;
					flex-basis: 740px;
					gap: 30px;
				}
				.thumnail {
					min-width: 124px;
					min-height: 124px;
					width: 124px;
					height: 124px;
				}

				.title-delete {
					height: 124px;
					justify-content: center;
					display: flex;
					position: relative;
					.title {
						height: 60px;
						font-size: 2.25rem;
						font-weight: 600;
					}

					#delete {
						position: absolute;
						bottom: 0;
						left: -29px;
					}
				}
				.clear-button {
					width: 26px;
					height: 26px;
				}
			}
		}
	}

</style>
